module Meevo.Plugins.Controls {

    declare let d3: any;
    declare let device;

    export interface ID3ChartOptions<T> {
        chart: T;
    }

    export abstract class BaseChart<T, K> implements ng.IComponentController {

        public data: K[] = [];
        public element: angular.IAugmentedJQuery;
        public touchCount = 0;
        public isMobile: boolean;

        protected title: string;
        protected mapFn?: (item: T) => K;
        protected inputData: (T | K)[];

        abstract options: Object;

        constructor(protected $scope: ng.IScope, protected $element: any, protected $timeout: ng.ITimeoutService) {
            this.data = [];
        }

        public prepareData() {
            this.data = typeof this.mapFn === 'function' ? this.inputData.map(this.mapFn) : this.inputData as K[];
        }

        $onInit() {
            this.isMobile = device.mobile();
            this.prepareData();

            // For mobile only - ensure zooming for touch events when > 1 finger
            if (this.isMobile) {
                this.element.on('touchstart', (e) => {
                    if (e.originalEvent['touches']) this.touchCount = e.originalEvent['touches'].length;
                });
            }

            this.$scope.$watch(() => this.inputData, (value) => {
                if (!value) return;
                this.prepareData();

                // For mobile only - add zoom detection to element after childviews loaded
                if (this.isMobile) {
                    this.$timeout(() => {
                        this.addTouchDetection();
                    }, 1000);
                }
            });
        }


        public addTouchDetection() {
            const selection = d3.select(this.element[0]).select('.nvd3-svg');
            const zoomable_layer = selection.select('.nvd3');
            const height = 450;
            const width = Number(selection.style('width').replace('px', ''));

            // Define zoom behavior
            const zoom = d3.behavior.zoom()
                .scaleExtent([1, 4])
                .on('zoom', () => {
                    const e = d3.event;
                    const tx = Math.min(0, Math.max(e.translate[0], width - width * e.scale));
                    const ty = Math.min(0, Math.max(e.translate[1], height - height * e.scale));

                    // If one finger, scroll normally
                    if (this.touchCount === 1 && e.sourceEvent) {
                        e.sourceEvent.stopPropagation();

                        return;
                    }

                    // Otherwise zoom/move
                    zoom.translate([tx, ty]);
                    zoomable_layer.style('stroke-width', 1 / e.scale).attr('transform', 'translate(' + [tx, ty] + ')scale(' + e.scale + ')');
                });

            selection.call(zoom);
        }
    }
}
